import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout route for the Owner BI dashboard. The /admin parent route gates on the
// `admin` role server-side, so this subtree inherits that guard — no extra check
// here (matches admin.costumes.tsx, admin.reports.tsx, and every other admin.*
// route).
export const Route = createFileRoute('/admin/bi')({
  component: BiRoute,
});

function BiRoute() {
  return <Outlet />;
}
